import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../../../_services/quote.service';

import { ResultData } from 'src/app/_models/ResultData';
import { DataUtilService } from 'src/app/_services/data-util.service';
@Component({
  selector: 'app-quote-two',
  templateUrl: './quote-two.component.html',
  styleUrls: ['./quote-two.component.css']
})
export class QuoteTwoComponent implements OnInit {
  public quote={author:"",body:"",source:"",imagePosition:1}
  loading=false
  constructor(private quoteService:QuoteService, private dataUtilService:DataUtilService) { }


  ngOnInit(): void {
    this.loading=true
    this.quoteService.getQuotes().subscribe({
      next:(data:ResultData)=>{
        let quotes = data.rs.data
        let quoteLower = quotes.length/2
        let index = this.dataUtilService.getRandomInt(quoteLower,quotes.length-1)
        this.quote = quotes[index]


        this.loading = true
      },error:(err)=>{
        console.error("Error loading quote",err)
      }

      })

  }
  }

